export default __webpack_public_path__ + "static/app@2x-d8391abf038ca51ba1ad0daa0f14460c.png";